import $ from 'jquery';
import pdfobject from 'pdfobject';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';
import { getState } from '~src/state';
import { gridProvinoIsEnabled } from '~src/utils';
import { generateGrid } from './generateGrid';
import customLayouts from './customLayouts';

export const previewGridPdf = async () => {
  const editorMode = getState('editorMode');

  if (editorMode !== EDITOR_MODE_DEFAULT) {
    return;
  }

  const isGridProvinoEnabled = gridProvinoIsEnabled();
  const canvasIsInitialized = typeof window.canvas.getObjects !== 'undefined';

  if (!canvasIsInitialized || !isGridProvinoEnabled) {
    return;
  }

  const pdfParameters = $('#navbar-submenu-export-provino-output').select2(
    'data'
  );

  const grigliaProvinoFormatId = pdfParameters[0].id;
  const gridGenerator =
    customLayouts[grigliaProvinoFormatId]?.default || generateGrid;

  if (pdfParameters[0].allowUserToManageMargins === false) {
    $('#export-selector-provino-manage-margins').hide();
  } else {
    $('#export-selector-provino-manage-margins').show();
  }

  try {
    const pdf = await gridGenerator();
    const preview = pdf.pdfGrid.output('bloburl');
    pdfobject.embed(
      preview + '#toolbar=0&navpanes=0&scrollbar=0',
      '#provino-preview'
    );
  } catch (err) {
    console.error(err);
  }
};
